﻿// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple capitalize function.
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        getHtmlLang() {
            return document.documentElement.lang;
        },
        // Simple date object handler.
        toDateObj(dateString) {
            return new Date(dateString);
        },
        // Simple date string handler.
        toDateStr(dateString) {
            const dateObj = this.toDateObj(dateString);
            const lang = this.getHtmlLang();
            return dateObj.toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' });
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    cb(...args);
                }, delay);
            };
        },
    },
};

export default mixin;
